import moment, { utc } from 'moment';
import { LockTimeType } from 'data/constant';

export const isPassed = (startTime: string, lock: LockTimeType) => {
	const currentUtc = utc();
	const startUtc = utc(startTime);

	const elapsed = currentUtc.diff(startUtc, lock.difference);

	const newTimeUtc = startUtc.clone().add(lock.duration, lock.difference);

	const newTimeLocalString = newTimeUtc.local();

	return {
		isLocked: elapsed < lock.duration,
		newTime: newTimeLocalString,
	};
};

export const getLockMessage = (canWithdraw?: boolean) => {
	const forcedUnlockMoment = moment(
		'2025-01-06 00:00:00',
		'YYYY-MM-DD HH:mm:ss',
	);
	const now = moment();

	if (now.isBefore(forcedUnlockMoment)) {
		return `Claim at ${forcedUnlockMoment.format('DD-MMM, hh:mm A')}`;
	}

	return canWithdraw ? 'Withdraw' : 'Claim';
};

export const isLocked = () => {
	const forcedUnlockMoment = moment(
		'2025-01-06 00:00:00',
		'YYYY-MM-DD HH:mm:ss',
	);
	const now = moment();

	return now.isBefore(forcedUnlockMoment);
};
